import { type AxiosPromise } from 'axios';
import { httpWithAuth } from '~/clients';
import { REMOVE_FAVORITE } from '~/constants/endpoints';
import { type DeleteFavoriteVehicleResponse } from '~/contracts/common';

export default function removeFavorite(
  vehicleId: number
): AxiosPromise<DeleteFavoriteVehicleResponse> {
  return httpWithAuth.post(REMOVE_FAVORITE, {
    vehicleId
  });
}
